/// <reference types="@capacitor/cli" />
export {};
//# sourceMappingURL=definitions.js.map